/** Local drive for order folders (always Z:). */
export const ORDER_FOLDER_BASE_PATH = 'Z:';

/**
 * localexplorer: links for Local Explorer Integration Module.
 * Example: localexplorer:Z:%5C2026%5C7%5C1213231
 * (backslash must be %5C — raw \ is blocked by modern Chrome)
 */
export function toLocalExplorerUrl(windowsPath) {
    return 'localexplorer:' + String(windowsPath).replace(/\\/g, '%5C');
}

function resolveOrderMonth(order) {
    const date = order?.dateOfReceipt;
    if (date == null) {
        return null;
    }
    if (Array.isArray(date) && date.length >= 2) {
        const month = Number(date[1]);
        return Number.isFinite(month) && month >= 1 && month <= 12 ? month : null;
    }
    const parsed = new Date(date);
    if (Number.isNaN(parsed.getTime())) {
        return null;
    }
    return parsed.getMonth() + 1;
}

/** Example: Z:\2026\7\1213231 */
export function buildOrderFolderPath(order) {
    const year = order?.year;
    const number = order?.number;
    const month = resolveOrderMonth(order);
    if (year == null || number == null || month == null) {
        return null;
    }
    return `${ORDER_FOLDER_BASE_PATH}\\${year}\\${month}\\${number}`;
}

export async function copyTextToClipboard(text) {
    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (_) {
            // fall through
        }
    }
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    let ok = false;
    try {
        ok = document.execCommand('copy');
    } catch (_) {
        ok = false;
    }
    textarea.remove();
    return ok;
}
